<template>
  <v-card class="elevation-0" outlined>
    <v-toolbar color="indigo" dense>
      <v-row align="center" justify="center">
        <v-autocomplete
          dense
          hide-details
          :items="items_dist_alt"
          item-text="nome_distinta"
          item-value="id_articolo_distinta_base_alternativa"
          :key="key_autocomplete"
          style="background-color: white"
          v-model="distinta_sel_display"
        >
          <template v-slot:item="{ item }">
            <v-icon
              class="mr-5"
              :color="item.predefinita == 0 ? 'primary' : 'success'"
              >{{ item.predefinita == 0 ? "mdi-circle" : "mdi-check-circle" }}
            </v-icon>
            {{ item.nome_distinta }}
          </template>
        </v-autocomplete>

        <v-spacer></v-spacer>

        <!-- Bottone per salvare le modifiche effettuate -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="salvataggioGenerale"
              small
              v-bind="attrs"
              v-on="on"
              v-show="dialog_mode === false"
            >
              <v-icon color="success"> mdi-floppy </v-icon>
            </v-btn>
          </template>
          <span>Salva Distinte</span>
        </v-tooltip>

        <!-- Bottone per rendere predefinita la distinta base corrente-->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="registraStandard"
              :disabled="
                items_dist_alt.length === 0 || distinta_sel_display == null
              "
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="success"> mdi-check </v-icon>
            </v-btn>
          </template>
          <span>{{
            dialog_mode === true ? `Scegli Distinta` : `Distinta Standard`
          }}</span>
        </v-tooltip>

        <!-- Bottone per aggiungere una nuova distinta base -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="aggiungiDistinta"
              small
              v-bind="attrs"
              v-on="on"
              v-show="dialog_mode === false"
            >
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi Distinta</span>
        </v-tooltip>

        <!-- Bottone di modifica della distinta attuale -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="modificaDistinta"
              :disabled="
                items_dist_alt.length === 0 || distinta_sel_display == null
              "
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modifica Distinta</span>
        </v-tooltip>

        <!-- Bottone per comprimere la treeview -->
        <v-tooltip bottom v-if="treeview_espansa === true">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="comprimiTutto"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary">mdi-arrow-collapse</v-icon>
            </v-btn>
          </template>
          <span>Comprimi</span>
        </v-tooltip>

        <!-- Bottone per espandere la treeview -->
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="
                open = [];
                espandiTutto(
                  items_dist_alt.filter(
                    (d) =>
                      d.id_articolo_distinta_base_alternativa ==
                      distinta_sel_display
                  )
                );
                treeview_espansa = true;
              "
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary">mdi-arrow-expand</v-icon>
            </v-btn>
          </template>
          <span>Espandi</span>
        </v-tooltip>

        <!-- Bottone per eliminare la distinta -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickEliminaDistinta"
              :disabled="
                items_dist_alt.length === 0 || distinta_sel_display == null
              "
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina Distinta</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickChiudi"
              small
              v-bind="attrs"
              v-on="on"
              v-show="show_close === true"
            >
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-row>
    </v-toolbar>

    <v-card-text>
      <!-- Treeview della distinta attualmente selezionata -->
      <v-treeview
        hoverable
        :open.sync="open"
        :items="
          items_dist_alt.filter(
            (d) =>
              d.id_articolo_distinta_base_alternativa == distinta_sel_display
          ).length > 0
            ? items_dist_alt.filter(
                (d) =>
                  d.id_articolo_distinta_base_alternativa ==
                  distinta_sel_display
              )[0].children
            : []
        "
        item-text=""
        item-key="id"
        open-on-click
        :key="key_treeview"
      >
        <template v-slot:prepend="{ item }">
          <b class="mr-2">{{ item.indice }}:</b>
          <v-icon> mdi-text-short </v-icon>
          <template>
            N°
            {{
              item.quantita != null &&
              item.quantita != undefined &&
              item.quantita != ""
                ? item.quantita.toString().replace(".", ",")
                : 0
            }}
            {{ item.name }}
          </template>
        </template>
        <template slot="append" slot-scope="{ item }">
          <span v-show="item.id_rif == -1 && dialog_mode === false">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    $event.stopPropagation();
                    clickAggiungiComponente();
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>Inserisci Componente</span>
            </v-tooltip>
          </span>

          <!-- Bottone per il Livello Qualità Accettabile -->
          <span v-show="item.id_rif == 0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mr-1"
                  @click="
                    $event.stopPropagation();
                    setLQA(item);
                  "
                  v-on="on"
                  small
                  :color="item.lqa === 1 ? 'success' : ''"
                >
                  <v-icon :color="item.lqa === 1 ? 'white' : 'primary'"
                    >mdi-link-box-variant</v-icon
                  >
                </v-btn>
              </template>
              <span>Tracciabilità Materia Prima</span>
            </v-tooltip>
          </span>

          <!-- Bottone per il materiale sotto-lotto (tracciabilità lotti) -->
          <span v-show="item.id_rif == 0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mr-5"
                  @click="
                    $event.stopPropagation();
                    setMaterialeSottoLotto(item);
                  "
                  v-on="on"
                  small
                  :color="item.materiale_sotto_lotto === 1 ? 'success' : ''"
                >
                  <v-icon
                    :color="
                      item.materiale_sotto_lotto === 1 ? 'white' : 'primary'
                    "
                    >mdi-map-marker-path</v-icon
                  >
                </v-btn>
              </template>
              <span>Materiale Sotto-Lotto</span>
            </v-tooltip>
          </span>

          <!-- Bottone per vedere il dettaglio del componente -->
          <span v-show="item.id_rif == 0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="
                    $event.stopPropagation();
                    getDettaglioArticolo(item);
                  "
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="blue">mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Dettaglio Componente</span>
            </v-tooltip>
          </span>
          <span v-show="item.id_rif == 0 && dialog_mode === false">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="
                    $event.stopPropagation();
                    modificaComponente(item);
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Modifica Componente</span>
            </v-tooltip>
          </span>

          <span v-show="item.id_rif == 0 && dialog_mode === false">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-1"
                  @click="
                    $event.stopPropagation();
                    clickEliminaComponente(item);
                  "
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-window-close</v-icon>
                </v-btn>
              </template>
              <span>Cancella Componente</span>
            </v-tooltip>
          </span>
        </template>
      </v-treeview>
    </v-card-text>

    <!-- Dialog per aggiungere una nuova distinta -->
    <v-dialog v-model="aggiungi_distinta" width="500px">
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">
            Nuova Distinta Base
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio della nuova distinta base -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaNuovaDistinta" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Nuova Distinta</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura del dialog della nuova distinta base -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiNuovaDistinta"
                small
                v-on="on"
                v-bind="attrs"
              >
                <v-icon color="red"> mdi-window-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0">
          <div class="mb-5">
            Inserire di seguito il nome della nuova distinta base
          </div>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="nome_nuova_distinta"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog per modificare il nome della distinta -->
    <v-dialog v-model="dialog_modifica_distinta" width="500px">
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">
            Modifica Nome Distinta
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio della nuova distinta base -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaDistinta"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Modifica</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura del dialog della nuova distinta base -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiModificaDistinta"
                small
                v-on="on"
                v-bind="attrs"
              >
                <v-icon color="red"> mdi-window-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0">
          <div class="mb-5">
            Modificare il nome della distinta base attualmente selezionata:
          </div>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="nome_distinta_modifica"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione di un componente -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialog_conferma_eliminazione"
      width="unset"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Eliminazione
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: black; font-size: 15px">
            Si conferma di voler eliminare questo componente dalla distinta
            base?
          </span>
        </v-card-text>
        <v-container>
          <v-row align="center" justify="center">
            <v-col colr="12">
              <v-btn class="mr-5" @click="chiudiConfermaEliminazione" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
              <v-btn @click="eliminaComponente" small>
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog di dettaglio dell'articolo selezionato -->
    <v-dialog persistent v-model="dialog_articolo">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Articolo Dettaglio
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                @click="chiudiDettaglioArticolo()"
                small
              >
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text
          style="max-height: 600px; overflow-y: auto; overflow-x: hidden"
          class="mt-6"
        >
          <Articolo
            :articoloId="this.id_articolo_sel"
            :key="this.id_articolo_sel"
            :name="this.id_articolo_sel"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog per l'inserimento / modifica dei componenti in Distinta Base -->
    <v-dialog persistent v-model="dialog_distinta_base" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Distinta Base </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickSalvaModifiche"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura del dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiModificaComponente"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-container>
            <!-- Riga del campo di ricerca per cod. articolo -->
            <v-row align="center" justify="center">
              <v-col class="mb-0 pb-0" cols="12" justify="left">
                <v-text-field
                  dense
                  :disabled="this.distinta_in_modifica === true"
                  label="Ricerca Componente"
                  style="max-width: 250px"
                  v-model="cod_articolo_search"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="searchCodArticolo"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-magnify</v-icon>
                        </v-btn>
                      </template>
                      <span>Cerca </span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Riga della tabella -->
            <v-row align="center" justify="center">
              <v-col class="ma-0 pa-0" cols="12">
                <v-data-table
                  :headers="headers"
                  :items="items_componenti_aggiuntivi"
                  :options.sync="options_update"
                >
                  <template v-slot:[`item.quantita`]="{ item }">
                    <v-text-field
                      class="centered-input"
                      :key="text_field_key"
                      min="0"
                      type="number"
                      v-model="item.quantita"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma della modifica di un componente -->
    <v-dialog v-model="conferma_update_distinta" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Modifica
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi di voler salvare le modifiche alla quantità del componente
            nella distinta base dell'articolo
          </span>
          <div class="my-5">
            <span style="font-size: 25px">
              <b>{{
                items_dist_alt.filter(
                  (d) =>
                    d.id_articolo_distinta_base_alternativa ==
                    distinta_sel_display
                ).length > 0
                  ? items_dist_alt.filter(
                      (d) =>
                        d.id_articolo_distinta_base_alternativa ==
                        distinta_sel_display
                    )[0].children[0].name
                  : ""
              }}</b>
            </span>
          </div>
          <v-divider class="my-5"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-btn
                  class="mr-5"
                  @click="conferma_update_distinta = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <!-- Bottone di conferma -->
                <v-btn @click="salvaModificaComponente" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma dell'eliminazione di una distinta -->
    <v-dialog
      persistent
      v-model="dialog_conferma_elimina_distinta"
      width="unset"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Eliminazione Distinta
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi di voler eliminare la distinta corrente?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_elimina_distinta = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <!-- Bottone di conferma -->
                <v-btn @click="eliminaDistinta" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma dell'aggiunta di uno o più nuovi componenti -->
    <v-dialog v-model="conferma_nuovi_componenti" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Aggiunta
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi di voler salvare le modifiche alla quantità del componente
            nella distinta base dell'articolo
          </span>
          <div class="my-5">
            <span style="font-size: 25px">
              <b>{{
                items_dist_alt.filter(
                  (d) =>
                    d.id_articolo_distinta_base_alternativa ==
                    distinta_sel_display
                ).length > 0
                  ? items_dist_alt.filter(
                      (d) =>
                        d.id_articolo_distinta_base_alternativa ==
                        distinta_sel_display
                    )[0].children[0].name
                  : ""
              }}</b>
            </span>
          </div>
          <v-divider class="my-5"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-btn
                  class="mr-5"
                  @click="conferma_nuovi_componenti = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <!-- Bottone di conferma -->
                <v-btn @click="salvaNuoviComponenti" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import _ from "lodash";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Distinta {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : _.cloneDeep(arg[c.nome])
            : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "children", default_val: [], complex: true },
      { nome: "id", default_val: null, complex: false },
      { nome: "id_articolo", default_val: null, complex: false },
      {
        nome: "id_articolo_distinta_base_alternativa",
        default_val: null,
        complex: false,
      },
      { nome: "id_componente", default_val: null, complex: false },
      { nome: "id_distinta_base", default_val: -1, complex: false },
      { nome: "id_rif", default_val: 0, complex: false },
      { nome: "materiale_sotto_lotto", default_val: 0, complex: false },
      { nome: "name", default_val: "", complex: false },
      { nome: "quantita", default_val: 1, complex: false },
      { nome: "validita", default_val: 1, complex: false },
    ];
    return campi;
  }
}

export default {
  name: "DistintaBaseAlt",
  components: {
    Articolo: () => import("@/views/PRODUCTION/Articolo/Articolo.vue"),
    SnackbarQV,
  },
  props: {
    articolo_sel: {
      type: Object,
      default: () => {},
    },
    dialog_mode: {
      type: Boolean,
      default: false,
    },
    show_close: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_articolo_search: "",
      distinta_sel: new Distinta(),
      distinta_sel_display: null,
      id_articolo_sel: null,
      key_autocomplete: 0,
      key_treeview: 0,
      nome_distinta_modifica: "",
      nome_nuova_distinta: "",
      options_update: {},
      text_field_key: 0,

      // Modal
      aggiungi_distinta: false,
      conferma_nuovi_componenti: false,
      conferma_update_distinta: false,
      dialog_articolo: false,
      dialog_conferma_elimina_distinta: false,
      dialog_conferma_eliminazione: false,
      dialog_distinta_base: false,
      dialog_modifica_distinta: false,
      distinta_in_modifica: false,
      overlay: false,
      treeview_espansa: false,

      // Array
      componenti_delete: new Array(),
      distinte_delete: new Array(),
      headers: [
        {
          text: "Q.tà Distinta",
          value: "quantita",
        },
        {
          text: "Codice Componente",
          value: "cod_articolo",
        },
        {
          text: "Descrizione",
          value: "des_articolo",
        },
        {
          text: "Tipo Articolo",
          value: "tipo_articolo",
        },
        {
          text: "Sub Tipo",
          value: "des_sub_tipo",
        },
        {
          text: "Fornitura",
          value: "id_tipo_fornitura",
        },
        {
          text: "Famiglia",
          value: "id_famiglia",
        },
        {
          text: "Sub famiglia",
          value: "des_sub_famiglia",
        },
      ],
      items_dist_alt: [],
      items_componenti_aggiuntivi: [],
      open: [],
    };
  },
  computed: {},
  watch: {
    options_update: {
      immediate: true,
      deep: true,
      handler() {
        this.text_field_key = this.text_field_key === 0 ? 1 : 0;
      },
    },
  },
  methods: {
    aggiungiDistinta() {
      // Rendo visibile il dialog della nuova distinta
      this.aggiungi_distinta = true;
    },
    chiudiConfermaEliminazione() {
      // Chiudo il dialog di conferma e resetto l'oggetto selezionato.
      this.dialog_conferma_eliminazione = false;
      this.distinta_sel = new Distinta();
    },
    chiudiDettaglioArticolo() {
      // Resetto l'articolo selezionato e chiudo la finestra di dialogo.
      this.dialog_articolo = false;
      this.id_articolo_sel = null;
    },
    chiudiModificaComponente() {
      /* Se stavo modificando, spengo il semaforo di modifica
       * e tolgo i campi accessori che avevo aggiunto per
       * convenienza di tabella. */
      if (this.distinta_in_modifica === true) {
        this.distinta_in_modifica = false;

        // Prendo dall'array principale l'indice dell'oggetto in modifica
        const index = this.items_dist_alt
          .filter(
            (d) =>
              d.id_articolo_distinta_base_alternativa ==
              this.distinta_sel_display
          )[0]
          .children[0].children.findIndex((d) => d.id == this.distinta_sel.id);

        /* Mi creo una copia dell'oggetto provvisorio
         * a cui tolgo i campi che non servono più. */
        const obj = _.cloneDeep(
          this.items_dist_alt
            .filter(
              (d) =>
                d.id_articolo_distinta_base_alternativa ==
                this.distinta_sel_display
            )[0]
            .children[0].children.filter((c) => c.id == this.distinta_sel.id)[0]
        );

        delete obj.cod_articolo;
        delete obj.des_articolo;
        delete obj.id_tipo;
        delete obj.des_sub_tipo;
        delete obj.id_tipo_fornitura;
        delete obj.id_famiglia;
        delete obj.des_sub_famiglia;

        // Aggiorno l'array principale
        this.$set(
          this.items_dist_alt.filter(
            (d) =>
              d.id_articolo_distinta_base_alternativa ==
              this.distinta_sel_display
          )[0].children[0].children,
          index,
          obj
        );
      }

      this.dialog_distinta_base = false;
      this.cod_articolo_search = "";
      this.items_componenti_aggiuntivi = new Array();
      this.distinta_sel = new Distinta();
    },
    chiudiModificaDistinta() {
      this.dialog_modifica_distinta = false;
    },
    chiudiNuovaDistinta() {
      /* Resetto il campo per il titolo della nuova
       * distinta e chiudo il dialog di salvataggio. */
      this.nome_nuova_distinta = "";
      this.aggiungi_distinta = false;
    },
    clickAggiungiComponente() {
      this.cod_articolo_search = "";
      this.items_componenti_aggiuntivi = [];
      this.distinta_in_modifica = false;
      this.distinta_sel = new Distinta();
      this.dialog_distinta_base = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickEliminaComponente(arg) {
      // Registro l'oggetto cliccato e apro il dialog di conferma.
      this.distinta_sel = new Distinta(arg);
      this.dialog_conferma_eliminazione = true;
    },
    clickEliminaDistinta() {
      this.dialog_conferma_elimina_distinta = true;
    },
    clickSalvaModifiche() {
      // Controllo che siano stati caricati dei componenti aggiuntivi.
      if (this.items_componenti_aggiuntivi.length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare i componenti da aggiungere prima di salvare."
        );
        return;
      }

      // Contollo che non ci siano quantità negative
      let chk_qta_negative = false;

      this.items_componenti_aggiuntivi.forEach((c) => {
        if (parseFloat(c.quantita) < 0) {
          chk_qta_negative = true;
        }
      });

      if (chk_qta_negative === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non sono accettate quantità inferiori a 0."
        );
        return;
      }

      // Controllo che ci siano componenti con quantità superiore a 0.
      let chk_solo_0 = true;
      this.items_componenti_aggiuntivi.forEach((c) => {
        if (parseFloat(c.quantita) > 0) {
          chk_solo_0 = false;
        }
      });

      if (chk_solo_0 === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire almeno un componente con quantità non nulla."
        );
        return;
      }

      /* A seconda se sto modificando o creando oggetti nuovi,
       *  */
      if (this.distinta_in_modifica === true) {
        this.conferma_update_distinta = true;
      } else if (this.distinta_in_modifica === false) {
        this.conferma_nuovi_componenti = true;
      }
    },
    comprimiTutto() {
      // Svuoto l'array dei nodi aperti e registro che la treeview è compressa.
      this.open = new Array();
      this.treeview_espansa = false;
    },
    eliminaComponente() {
      // Metto a 0 la validità del componente che ho selezionato
      const obj_tmp = this.items_dist_alt
        .filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
        )[0]
        .children[0].children.filter((c) => c.id == this.distinta_sel.id)[0];
      obj_tmp.validita = 0;

      // Aggiungo l'oggetto cancellato al cestino
      this.componenti_delete.push(_.cloneDeep(obj_tmp));

      // Prendo l'indice del componente selezionato
      const index = this.items_dist_alt
        .filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
        )[0]
        .children[0].children.findIndex((d) => d.id == this.distinta_sel.id);

      /* Elimino l'oggetto selezionato dall'array
       * degli oggetti renderizzati nella treeview. */
      this.items_dist_alt
        .filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
        )[0]
        .children[0].children.splice(index, 1);

      this.setIndiceRicorsivo(this.items_dist_alt);

      // Forzo l'aggiornamento del render della treeview.
      this.key_treeview = this.key_treeview === 0 ? 1 : 0;

      // Chiudo il dialog di conferma
      this.dialog_conferma_eliminazione = false;
    },
    eliminaDistinta() {
      let index = -1;

      for (let i = 0; i < this.items_dist_alt.length; i++) {
        if (
          this.items_dist_alt[i].id_articolo_distinta_base_alternativa ==
          this.distinta_sel_display
        ) {
          index = i;
        }
      }

      console.log("indice cancellato", index);
      this.items_dist_alt[index].validita = -1;
      this.distinte_delete.push(
        JSON.parse(JSON.stringify(this.items_dist_alt[index]))
      );

      this.items_dist_alt.splice(index, 1);
      this.distinta_sel_display = null;
      this.dialog_conferma_elimina_distinta = false;

      if (this.items_dist_alt.length > 0) {
        this.distinta_sel_display =
          this.items_dist_alt[
            this.items_dist_alt.length - 1
          ].id_articolo_distinta_base_alternativa;

        console.log("nuova distinta visualizzata: ", this.distinta_sel_display);
      }
    },
    espandiTutto(arr) {
      /* Inserisco gli identificativi di tutti i componenti
       * nell'array degli identificativi espansi. */
      arr.forEach((d) => {
        this.open.push(d.id);
        if (d.children) {
          this.espandiTutto(d.children);
        }
      });
      this.treeview_espansa = true;
    },
    getDettaglioArticolo(item) {
      this.dialog_articolo = true;
      this.id_articolo_sel = item.id;
    },
    getDistintaBase(arg) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolidistintabase",
          token: localStorage.user_token,
          id_articolo: arg,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.setIdRif(res.data[0].children);
            return res.data[0].children;
          } else {
            return [];
          }
        })
        .catch(() => {
          return [];
        });
    },
    getDistintaBaseList() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolidistintabasealternativa",
          token: localStorage.getItem("user_token"),
          id_articolo: this.articolo_sel.id_articolo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Resetto i principali array di supporto.
            this.items_dist_alt = new Array();
            this.componenti_delete = new Array();
            this.distinte_delete = new Array();

            // Registro le varie distinte base
            this.items_dist_alt = _.cloneDeep(res.data);

            /* Assegno un indice a tutte le distinte base possibili
             * e ai loro figli per stampare il numero di riga nella treeview. */
            this.setIndiceRicorsivo(this.items_dist_alt);

            // Cerco se c'è una distinta base predefinita
            let chk_predefinita_presente = false;
            this.items_dist_alt.forEach((d) => {
              if (d.predefinita === 1) {
                chk_predefinita_presente = true;
              }
            });

            /* Se c'è una distinta base predefinita la seleziono,
             * altrimenti seleziono la prima distinta dell'array. */
            if (chk_predefinita_presente === true) {
              this.items_dist_alt.forEach((d) => {
                if (d.predefinita === 1) {
                  this.distinta_sel_display =
                    d.id_articolo_distinta_base_alternativa;
                }
              });
            } else {
              if (this.items_dist_alt.length > 0) {
                this.distinta_sel_display =
                  this.items_dist_alt[0].id_articolo_distinta_base_alternativa;
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Non ci sono Distinte Base per questo articolo."
                );
              }
            }

            // Espando la treeview perché è più conveniente visualizzarne il dettaglio.
            this.espandiTutto(
              this.items_dist_alt.filter(
                (d) =>
                  d.id_articolo_distinta_base_alternativa ==
                  this.distinta_sel_display
              )
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, nonnnnn è stato possibile caricare i dati."
          );
        });
    },
    modificaDistinta() {
      this.nome_distinta_modifica = this.items_dist_alt.filter(
        (e) =>
          e.id_articolo_distinta_base_alternativa === this.distinta_sel_display
      )[0].nome_distinta;

      this.dialog_modifica_distinta = true;
    },
    registraStandard() {
      /* Controllo che la distinta attuale non sia già predefinita
       * e che il componente non sia in dialog mode perché nella
       * dialog mode posso indicare come predefinita qualsiasi distinta,
       * anche una che è già predefinita (serve solo per sceglierla,
       * non per salvarla sul BE). */
      if (
        this.items_dist_alt.filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa ==
              this.distinta_sel_display && d.predefinita == 1
        ).length > 0 &&
        this.dialog_mode === false
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La distinta base attualmente selezionata è già predefinita."
        );
        return;
      }

      /* Se la distinta attuale non era predefinita,
       * cerco una distinta che eventualmente fosse
       * già predefinita e la registro come non più predefinita.
       * poi registro la distinta attuale come predefinita e
       * mando una request al BE per l'aggiornamento dei dati. */
      this.items_dist_alt.forEach((d) => {
        if (
          d.id_articolo_distinta_base_alternativa !=
            this.distinta_sel_display &&
          d.predefinita === 1
        ) {
          d.predefinita = 0;
        } else if (
          d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
        ) {
          d.predefinita = 1;
        }
      });

      /* Se sono in modalità dialog eseguo il salvataggio
       * (non salva niente, ma emette la distinta selezionata
       * come predefinita); se invece non sono in modalità dialog
       * stampa una snackbar di conferma. */
      if (this.dialog_mode === true) {
        this.salvataggioGenerale();
      } else {
        this.$refs.SnackbarQV.print(
          "success",
          "Questa distinta è ora impostata come predefinita."
        );
      }
    },
    salvaModificaComponente() {
      this.items_dist_alt
        .filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
        )[0]
        .children[0].children.filter(
          (c) =>
            c.id_componente == this.items_componenti_aggiuntivi[0].id_articolo
        )[0].quantita = this.items_componenti_aggiuntivi[0].quantita;

      // Chiudo i dialog
      this.conferma_update_distinta = false;
      this.dialog_distinta_base = false;

      // Resetto le variabili di supporto
      this.distinta_in_modifica = false;
      this.items_componenti_aggiuntivi = new Array();
    },
    salvaModificaDistinta() {
      // Registro il cambiamento
      this.items_dist_alt.filter(
        (e) =>
          e.id_articolo_distinta_base_alternativa === this.distinta_sel_display
      )[0].nome_distinta = this.nome_distinta_modifica;

      // Resetto la variabile di supporto e chiudo il dialog.
      this.nome_distinta_modifica = "";
      this.dialog_modifica_distinta = false;
      this.key_autocomplete = this.key_autocomplete === 0 ? 1 : 0;
    },
    async salvaNuoviComponenti() {
      // Metto da parte gli elementi che hanno quantità non nulla
      const arr_tmp = _.cloneDeep(
        this.items_componenti_aggiuntivi.filter((e) => e.quantita > 0)
      );

      /* Eseguo un controllo per verificare se i
       * nuovi elementi erano già stati inseriti. */
      let chk_ricorre = false;

      arr_tmp.forEach((el_new) => {
        this.items_dist_alt
          .filter(
            (d) =>
              d.id_articolo_distinta_base_alternativa ==
              this.distinta_sel_display
          )[0]
          .children[0].children.forEach((el_old) => {
            if (el_new.id_articolo === el_old.id_componente) {
              chk_ricorre = true;
            }
          });
      });

      if (chk_ricorre === true) {
        this.overlay = false;
        this.$refs.SnackbarQV.print(
          "orange",
          "Alcuni articoli sono già presenti in Distinta Base. Per cambiare la quantità usare le funzioni di modifica."
        );
        return;
      }

      // Se devo procedere all'aggiunta, faccio scattare l'overlay di caricamento.
      this.overlay = true;

      // Parso la quantità in numero in virgola mobile
      arr_tmp.forEach((el) => {
        if (el.quantita > 0) {
          // Forzo un numero in virgola mobile
          el.quantita = parseFloat(el.quantita);
        }
      });

      var distinta_in_modifica = new Distinta(
        this.items_dist_alt.filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa ===
            this.distinta_sel_display
        )[0].children[0]
      );

      if (distinta_in_modifica.id_articolo == null) {
        delete distinta_in_modifica.id_articolo;
      }
      if (distinta_in_modifica.id_componente == null) {
        delete distinta_in_modifica.id_componente;
      }
      console.log(distinta_in_modifica);

      /* Per ogni elemento dentro l'array temporaneo
       * genero un oggetto Distinta e lo inserisco
       * nella distinta principale che uso per il
       * salvataggio dei dati sul BE. */
      for (const e of arr_tmp) {
        var obj_tmp = new Distinta();
        obj_tmp.id = e.id_articolo;
        obj_tmp.id_articolo = this.articolo_sel.id_articolo;
        obj_tmp.id_articolo_distinta_base_alternativa =
          this.distinta_sel_display;
        obj_tmp.id_componente = e.id_articolo;
        obj_tmp.id_distinta_base =
          -moment().valueOf() + distinta_in_modifica.children.length;
        obj_tmp.name = `PZ x ${e.cod_articolo} : ${e.des_articolo}`;
        obj_tmp.quantita = e.quantita;
        obj_tmp.children = await this.getDistintaBase(obj_tmp.id_componente);
        distinta_in_modifica.children.push(Object.assign({}, obj_tmp));
      }

      /* Aggiorno l'array principale con una set altrimenti ci sono problemi
       * di reattività per la v-data-table che deve rappresentare i dati. */
      this.items_dist_alt.filter(
        (d) =>
          d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
      )[0].children = [distinta_in_modifica];

      // Aggiungo gli indici ai vari elementi degli array
      this.setIndiceRicorsivo(this.items_dist_alt);

      // Chiudo i dialog
      this.conferma_nuovi_componenti = false;
      this.dialog_distinta_base = false;
      this.overlay = false;

      // Resetto le variabili di supporto
      this.items_componenti_aggiuntivi = new Array();
      this.cod_articolo_search = "";
    },
    salvaNuovaDistinta() {
      // Controllo che il nome della nuova distinta sia valorizzato.
      if (
        this.nome_nuova_distinta === null ||
        this.nome_nuova_distinta === "" ||
        this.nome_nuova_distinta === undefined
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Inserire un nome non nullo per la nuova distinta."
        );
      }

      // Controllo che il nome della nuova distinta non sia già stato utilizzato
      let chk_nome_usato = false;
      this.items_dist_alt.forEach((d) => {
        if (d.nome_distinta === this.nome_nuova_distinta) {
          chk_nome_usato = true;
        }
      });

      if (chk_nome_usato === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il nome indicato è già impiegato per identificare un'altra Distinta Base di questo Articolo."
        );
        return;
      }

      // Costruisco l'articolo di default, che è più o meno uguale per tutte le distinte.
      const id_tmp = -moment().valueOf();

      const articolo_default = {
        id: this.articolo_sel.id_articolo,
        quantita: 1,
        name: this.articolo_sel.cod_articolo,
        id_articolo_distinta_base_alternativa: id_tmp,
        id_rif: -1,
        children: [],
      };

      // Inserisco l'articolo di default nella nuova distinta
      const nuova_distinta = {
        children: [articolo_default],
        id_articolo: this.articolo_sel.id_articolo,
        id_articolo_distinta_base_alternativa: id_tmp,
        nome_distinta: this.nome_nuova_distinta,
        numero_variante: 0,
        predefinita: 0,
      };

      // Assegno all'articolo standard della nuova distinta il riferimento al padre.
      nuova_distinta.children[0].id_articolo_distinta_base_alternativa =
        nuova_distinta.id_articolo_distinta_base_alternativa;

      this.items_dist_alt.push(nuova_distinta);

      // Riassegno gli indici
      this.setIndiceRicorsivo(this.items_dist_alt);

      // Resetto le variabili di supporto.
      this.nome_nuova_distinta = "";
      this.aggiungi_distinta = false;

      if (this.items_dist_alt.length > 0) {
        this.distinta_sel_display =
          this.items_dist_alt[
            this.items_dist_alt.length - 1
          ].id_articolo_distinta_base_alternativa;
      }
    },
    salvataggioGenerale() {
      // Preparo un array per il salvataggio.
      const arr_tmp = _.cloneDeep(this.items_dist_alt);

      // Aggiungo le distinte che ho eliminato.
      this.distinte_delete.forEach((d) => {
        arr_tmp.push(JSON.parse(JSON.stringify(d)));
      });

      // Aggiungo i nodi eliminati che devo comunicare al BE.
      arr_tmp.forEach((d) => {
        this.componenti_delete.forEach((o) => {
          if (
            o.id_articolo_distinta_base_alternativa ==
              d.id_articolo_distinta_base_alternativa &&
            o.id_distinta_base > 0
          ) {
            o.children = [];
            d.children[0].children.push(Object.assign({}, o));
          }
        });
      });

      /* Metto gli identificativi a -1 per le distinte
       * alternative nuove per convenienza di BE. */
      arr_tmp.forEach((d) => {
        if (parseInt(d.id_articolo_distinta_base_alternativa) < 0) {
          d.id_articolo_distinta_base_alternativa = -1;
          d.id_temp = moment().valueOf();
          d.children.forEach((c) => {
            c.id_articolo_distinta_base_alternativa = -1;
            c.id_temp = d.id_temp;
            c.children.forEach((n) => {
              n.id_temp = d.id_temp;
              n.id_articolo_distinta_base_alternativa = -1;
              n.id_distinta_base = -1;
            });
          });
        }
      });

      /* Metto a -1 gli identificativi di eventuali
       * componenti nuovi nelle distinte vecchie. */
      arr_tmp.forEach((d) => {
        d.children.forEach((c) => {
          c.children.forEach((n) => {
            if (parseInt(n.id_distinta_base) < 0) {
              n.id_distinta_base = -1;
            }
          });
        });
      });

      /* Se sono in modalità dialog, devo solo emettere la
       * distinta che è stata selezionata come predefinita. */
      if (this.dialog_mode === true) {
        const arr_res_tmp = 
          arr_tmp
            .filter((d) => d.predefinita == 1)[0]
            .children[0].children.filter((c) => c.validita != 0);

        // Controllo che non ci siano articoli doppi.
        let chk_articoli_doppi = false;

        arr_res_tmp.forEach((elem) => {
          if (
            arr_res_tmp.filter(
              (e) => e.id_componente == elem.id_componente && e.validita == 1
            ).length > 1
          ) {
            chk_articoli_doppi = true;
          }
        });

        if (chk_articoli_doppi) {
          this.$refs.SnackbarQV.print(
            "error",
            "Non è possibile selezionare distinte con articoli doppi."
          );
          return;
        }

        // Se tutto è andato bene, emetto la distinta base.
        this.$emit(
          "selezionata_distinta",
          arr_tmp
            .filter((d) => d.predefinita == 1)[0]
            .children[0].children.filter((c) => c.validita != 0)
        );
        return;
      }

      /* Elimino i componenti di secondo livello
       * perché non mi servono per il salvataggio. */
      arr_tmp.forEach((d) => {
        d.children.forEach((c) => {
          c.children.forEach((n) => {
            n.children = [];
          });
        });
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setdistintabasealternativa",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;

          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati con successo."
            );
            this.getDistintaBaseList();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    searchCodArticolo() {
      if (this.distinta_in_modifica === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non è possibile ricercare un articolo mentre si modifica la quantità di un componente della Distinta Base."
        );
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          cod_articolo: this.cod_articolo_search,
          token: localStorage.user_token,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            console.log("entrato 1");
            if (res.data.lista.length === 0) {
              console.log("entrato 2");
              this.$refs.SnackbarQV.print(
                "orange",
                "L'articolo non è stato trovato."
              );
              return;
            }
            console.log("entrato 3");

            // Se il BE mi ha restituito dei risultati...
            if (res.data.lista.length > 0) {
              this.items_componenti_aggiuntivi = res.data.lista.filter(
                (a) => a.cod_articolo != this.articolo_sel.cod_articolo
              );

              this.items_componenti_aggiuntivi.forEach((c) => {
                c.quantita = 0;
              });

              console.log(this.items_componenti_aggiuntivi.length);
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    setIdRif(array) {
      array.forEach((elem) => {
        elem.id_rif = parseInt(elem.id_rif) + 1;
        if (elem.children && elem.children.length > 0) {
          this.setIdRif(elem.children);
        }
      });
    },
    setIndiceRicorsivo(array) {
      array.forEach((elem) => {
        elem.indice = array.indexOf(elem) + 1;
        if (elem.children && elem.children.length > 0) {
          this.setIndiceRicorsivo(elem.children);
        }
      });
    },
    setLQA(arg) {
      this.items_dist_alt
        .filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
        )[0]
        .children[0].children.forEach((c) => {
          if (c.id == arg.id) {
            c.lqa = c.lqa == 0 ? 1 : 0;
          }
        });
      this.salvataggioGenerale();
    },
    setMaterialeSottoLotto(arg) {
      this.items_dist_alt
        .filter(
          (d) =>
            d.id_articolo_distinta_base_alternativa == this.distinta_sel_display
        )[0]
        .children[0].children.forEach((c) => {
          if (c.id !== arg.id) {
            c.materiale_sotto_lotto = 0;
          } else {
            c.materiale_sotto_lotto = 1;
          }
        });
      this.salvataggioGenerale();
    },
    modificaComponente(arg) {
      if (arg.name.includes(" x ") && arg.name.includes(" : ")) {
        this.cod_articolo_search = arg.name.split(" x ")[1].split(" : ")[0];

        const request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticoli",
            cod_articolo: this.cod_articolo_search,
            token: localStorage.user_token,
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status === 200) {
              if (res.data.lista.length > 0) {
                // All'oggetto che mi è stato restituito dal BE aggiungo la quantita
                res.data.lista[0].quantita = this.items_dist_alt
                  .filter(
                    (d) =>
                      d.id_articolo_distinta_base_alternativa ==
                      this.distinta_sel_display
                  )[0]
                  .children[0].children.filter(
                    (d) => d.id == arg.id
                  )[0].quantita;

                // Metto l'oggetto nell'array puntato dalla tabella per la modifica
                this.items_componenti_aggiuntivi = [];
                this.items_componenti_aggiuntivi.push(res.data.lista[0]);
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Non sono stati trovati dati per il cod. articolo selezionato."
                );
              }
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non è stato possibile caricare i dati."
              );
            }
          })
          .catch(() => {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          });
      }

      this.distinta_in_modifica = true;
      this.distinta_sel = new Distinta(arg);
      this.items_componenti_aggiuntivi = new Array();
      this.items_componenti_aggiuntivi.push(arg);
      this.dialog_distinta_base = true;
    },
  },
  created() {},
  mounted() {
    this.getDistintaBaseList();
  },
};
</script>
<style scoped>
</style>